"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlaceholder = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const VideoPlaceholder = ({
  isActive
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.VideoPlaceholderRoot, {
  isActive: isActive,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.VideoPlaceholderBackground, {})
});
exports.VideoPlaceholder = VideoPlaceholder;
//# sourceMappingURL=VideoPlaceholder.js.map